// Password reset dialog for a single user.
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { useT } from '@/i18n/LanguageContext';

export const ResetPasswordDialog = ({ pwReset, resetPw, setResetPw, onClose, onSubmit }) => {
  const { t } = useT();
  return (
    <Dialog open={!!pwReset} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="user-reset-pw-dialog">
        <DialogHeader>
          <DialogTitle>{t('users.resetPwTitle')}</DialogTitle>
        </DialogHeader>
        {pwReset && (
          <div className="space-y-3">
            <p className="text-xs text-zinc-600">
              {t('users.resetPwDesc', { name: pwReset.name })}
            </p>
            <Input
              type="text"
              value={resetPw}
              onChange={(e) => setResetPw(e.target.value)}
              placeholder={t('users.resetPwPh')}
              data-testid="reset-pw-input"
              autoComplete="new-password"
            />
            <p className="text-[11px] text-zinc-400">
              {t('users.resetPwNote')}
            </p>
          </div>
        )}
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={onClose} className="w-full sm:w-auto">
            {t('common.cancel')}
          </Button>
          <Button onClick={onSubmit} data-testid="reset-pw-submit" className="bg-teal-700 hover:bg-teal-800 w-full sm:w-auto">
            {t('users.reset')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
